import MarinSSO from 'marin-sso';

export abstract class Component {
  protected marinSSO: MarinSSO;

  constructor() {
    this.marinSSO = window.marinSSO;
  }
}

export default Component;
